import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import IconButton from '@material-ui/core/IconButton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';

// import HelpIcon from '@material-ui/icons/Help';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import HelpIcon from '@material-ui/icons/Help';

import FormActionButtons from '../form-action-buttons/FormActionButtons';
import { Input, Switch, CheckboxInput, CheckboxButtonsGroup } from 'components';
import { SwitchInput } from 'components';

import validate from './validate';

import useStyles from './styles';

const initialValues = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  companyName: '',
  referencePrefix: '',
  email: '',
  isNotify: ''
};

const styles = {
  // use "icon" instead of "thumb" in v3
  thumb: {
    borderRadius: 0
  }
};

const BusinessOwnerForm = ({ handleSubmit, open, onClose, isUpdate }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const [checked, setChecked] = useState(false);

  const [value, setValue] = useState('True');

  const onChangeHandler = e => {
    if (e.target.value) {
      const emailNotification = 'true';
    } else {
      const emailNotification = 'false';
    }
  };

  return (
    <Dialog open={open} classes={{ paper: classes.paper }}>
      <IconButton className={classes.closeBtn} onClick={onClose}>
        <HighlightOffIcon className={classes.closeIcon} />
      </IconButton>
      <DialogTitle
        id="alert-dialog-title"
        classes={{ root: classes.title }}
        disableTypography={true}
      >
        {t('Business Owner')}
      </DialogTitle>
      <div className={classes.formWrapper}>
        <form onSubmit={handleSubmit}>
          {/*<div>
           <Field
              name="emailNotification"
              checked={true}
              label="Email notification*"
              type="checkbox"
              value={true}
              defaultChecked={true}
              placeholder="Email"
              component={CheckboxInput}
              className={classes.inlineSwitch}
            />
          </div> */}
          <div className={classes.inlineInputs}>
            <Field
              className={classes.input}
              name="firstName"
              label="First name *"
              placeholder="First name"
              component={Input}
            />
            <Field
              name="lastName"
              label="Last name *"
              className={classes.input}
              placeholder="Last name"
              component={Input}
            />
          </div>
          <div className={classes.inlineInputs}>
            <Field
              className={classes.input}
              name="email"
              disabled={!!isUpdate}
              label="Email *"
              placeholder="Email"
              component={Input}
            />
            <Field
              name="phoneNumber"
              label="Phone *"
              className={classes.input}
              isOnlyNumber={true}
              isPhoneNumber={true}
              maxLength={20}
              placeholder="Phone"
              component={Input}
            />
          </div>
          {!isUpdate && (
            <Field
              name="companyName"
              label="Company name *"
              placeholder="Company name"
              component={Input}
              className={classes.inputIndent}
            />
          )}
          {isUpdate && (
            <div className={classes.inlineInputs}>
              <Field
                className={classes.input}
                name="companyName"
                label="Company name *"
                placeholder="Company name"
                component={Input}
              />
              <Field
                className={classes.input}
                name="referencePrefix"
                label="Reference prefix *"
                disabled={true}
                placeholder="Reference prefix"
                component={Input}
              />
            </div>
          )}
          <Field
            name="isNotify"
            className={classes.checkbox}
            component={CheckboxButtonsGroup}
          />
          <Button
            variant="outlined"
            onClick={handleSubmit}
            className={classes.selectBOButton}
          >
            {t('Select Business Owner')}
          </Button>
          {/* <Field
            name="selectBusinessOwner"
            className={classes.checkbox}
            component={CheckboxButtonsGroup}
            popover={
              <PopoverWrapper text="Please select Business Owner Company to view all appropriate data within Admin Portal">
                <HelpIcon className={classes.helpIcon} />
              </PopoverWrapper>
            }
          /> */}
          <div className={classes.actionsBtns}>
            <FormActionButtons
              cancelPath="/business-owners"
              cancelCallback={onClose}
              actionLabel={isUpdate ? 'Save' : 'Create'}
            />
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default reduxForm({
  form: 'businessOwnerForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  initialValues,
  validate
})(connect(null)(BusinessOwnerForm));
